import * as Types from '../types';

import gql from 'graphql-tag';
export type BettorFragment = { __typename?: 'Bettor', id: string, rawToPayout: string, rawInBets: string, rawTotalPayout: string, rawTotalProfit: string, betsCount: number, wonBetsCount: number, lostBetsCount: number };

export const BettorFragmentDoc = gql`
    fragment Bettor on Bettor {
  id
  rawToPayout
  rawInBets
  rawTotalPayout
  rawTotalProfit
  betsCount
  wonBetsCount
  lostBetsCount
}
    `;